<script>
import Layout from '@layouts/main.vue'
import LocationRestrictionList from '@components/locationRestrictions/location-restriction-list.vue'
import NewRestrictionCreator from '@components/locationRestrictions/new-restriction-creator.vue'
import { mapActions, mapGetters } from 'vuex'
import AdminSelector from '@components/user/admin-selector.vue'
import LocationRestrictionRemover from '@components/locationRestrictions/location-restriction-remover.vue'
import LocationRestrictionExtender from '@components/locationRestrictions/location-restriction-extender.vue'

export default {
  components: {
    LocationRestrictionExtender,
    LocationRestrictionRemover,
    AdminSelector,
    Layout,
    LocationRestrictionList,
    NewRestrictionCreator,
  },
  data() {
    return {
      isNewBlockCreatorShowing: false,
      selectedAdmins: [],
      search: null,
      remove: {
        /** @type {?LocationRestriction} */
        selected: null,
        isConfShowing: false,
        isLoading: false,
      },
      extend: {
        /** @type {?LocationRestriction} */
        selected: null,
        isExtenderShowing: false,
        isLoading: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'auth/currentUser',
      getUserTeams: 'auth/currentUserTeams',
      getStaff: 'staff/getStaff',
      getViewableAdminIds: 'locationRestriction/getViewableAdminIds',
    }),
  },
  async created() {
    await this.loadStaff()
    this.selectedAdmins = [this.getUser.id.toString()]
  },
  methods: {
    ...mapActions({
      loadStaff: 'staff/initialiseStaff',
      removeRestriction: 'locationRestriction/removeRestriction',
      extendRestriction: 'locationRestriction/extendRestriction',
    }),
    handleRemoveSelected(restriction) {
      this.remove.isConfShowing = true
      this.remove.selected = restriction
    },
    handleExtendSelected(restriction) {
      this.extend.isExtenderShowing = true
      this.extend.selected = restriction
    },
    handleRemoveCancel() {
      this.remove.isConfShowing = false
    },
    handleExtenderCancel() {
      this.extend.isExtenderShowing = false
    },
    async handleRemoveConfirmed() {
      this.remove.isLoading = true
      const res = await this.removeRestriction(this.remove.selected.id)
      if (res.isSuccess) {
        this.remove.isConfShowing = false
        this.remove.isLoading = false
      }
    },
    async handleExtendConfirmed(newDate) {
      this.extend.isLoading = true
      const res = await this.extendRestriction({
        restriction: this.extend.selected,
        newUntilDate: newDate,
      })
      if (res.isSuccess) {
        this.extend.isExtenderShowing = false
        this.extend.isLoading = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle
      :title="$t('locationRestrictions.title')"
      :subtitle="$t('locationRestrictions.listTitle')"
    />
    <v-row>
      <v-col>
        <div>
          <div class="d-flex justify-space-between align-center pb-2">
            <div class="d-flex-column justify-center">
              <div class="d-flex justify-end align-end">
                <v-text-field
                  v-model="search"
                  class="mx-2 flex-grow-0"
                  prepend-icon="mdi-magnify"
                  :label="$t('locationRestrictions.list.searchLabel')"
                ></v-text-field>
                <AdminSelector
                  v-model="selectedAdmins"
                  :allowed-admin-ids="getViewableAdminIds"
                />
              </div>
            </div>
            <NewRestrictionCreator
              ref="newBlockCreator"
              v-model="selectedAdmins"
              :showing="isNewBlockCreatorShowing"
            />
          </div>

          <LocationRestrictionList
            :admin-ids="selectedAdmins"
            :search="search"
            @remove="handleRemoveSelected"
            @extend="handleExtendSelected"
          />

          <v-dialog v-model="extend.isExtenderShowing" max-width="500">
            <LocationRestrictionExtender
              :selected="extend.selected"
              :loading="extend.isLoading"
              @save="handleExtendConfirmed"
              @cancel="handleExtenderCancel"
            />
          </v-dialog>

          <v-dialog v-model="remove.isConfShowing" max-width="500">
            <LocationRestrictionRemover
              v-model="remove.isConfShowing"
              :restriction="remove.selected"
              :loading="remove.isLoading"
              @confirm="handleRemoveConfirmed"
              @cancel="handleRemoveCancel"
            />
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </Layout>
</template>
